// Reuse existing module/screens/permissions; the same rules gate page, tab and child.
const session = { session_status: { type: '!=', value: 'Restricted' } };
const module = { use_Module_Approval: 1 };
export const requestAccess = { when: { whenSession: session, whenSys: module,
    whenUser: { Approval_request_approval: 1, Approval_can_approve: 1 }, whenUserType: 'OR' } };
export const documentAccess = { when: { whenSession: session, whenSys: module, whenUserScreen: 'WFApprovalPendings' } };
export const documentSettingsAccess = { when: { whenSession: session, whenSys: module, whenUserScreen: 'WFApprovalPolicys' } };
